<!-- src/app/time-attendance/components/payroll-sync/pages/payroll-booked-hours-history/payroll-booked-hours-history.component.html -->
<app-payroll-nav></app-payroll-nav>

<div class="history-page">
  <div
    class="toast show"
    *ngIf="toastMessage"
    [class.success]="toastKind === 'success'"
    [class.error]="toastKind === 'error'"
    [class.warning]="toastKind === 'info'"
    (click)="clearToast()"
    role="status"
    aria-live="polite"
  >
    <img
      class="icon"
      [src]="
        toastKind === 'success'
          ? '/success.png'
          : toastKind === 'error'
            ? '/fail.png'
            : '/warning.png'
      "
      alt=""
      aria-hidden="true"
    />

    <div class="toast-title">
      {{ toastKind === 'success' ? 'Success' : toastKind === 'error' ? 'Action needed' : 'Notice' }}
    </div>

    <div class="toast-body">{{ toastMessage }}</div>
  </div>

  <div class="page-header">
    <div class="title-block">
      <h2>Booked Hours History</h2>
      <p class="subtitle">Review all booked hour records used before payable hours are generated.</p>
    </div>
  </div>

  <div *ngIf="errorMessage" class="inline-error" role="status" aria-live="polite">
    <p class="body">{{ errorMessage }}</p>
    <button type="button" class="icon-btn" (click)="errorMessage = null" aria-label="Close">×</button>
  </div>

  <div class="history-card">
    <div class="card-head">
      <div class="head-left">
        <h3>Booked hours</h3>
        <div class="sub">{{ totalCount }} total booked hour records</div>
      </div>

      <div class="head-right">
        <button type="button" class="ghost-btn refresh-btn" (click)="refresh()" [disabled]="isLoading">
          Refresh
        </button>

        <label class="page-size">
          Rows
          <select [value]="pageSize" (change)="changePageSize($any($event.target).value)" [disabled]="isLoading">
            <option *ngFor="let size of pageSizeOptions" [value]="size">
              {{ size }}
            </option>
          </select>
        </label>
      </div>
    </div>

    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Employee</th>
            <th>Date</th>
            <th>Week</th>
            <th>Hours</th>
            <th>Status</th>
            <th>Pay Code</th>
            <th>Pay Group</th>
            <th>Project</th>
            <th>Company</th>
            <th>Department</th>
            <th>Worker Type</th>
            <th>WON</th>
            <th>Supervisor Approval</th>
            <th>Updated</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let row of rows; trackBy: trackById">

            <td>
              <div class="employee-cell">
                <span class="employee-name">{{ getEmployeeName(row) }}</span>
                <span class="muted">#{{ getEmployeeNumber(row) }}</span>
              </div>
            </td>

            <td>{{ getBookedDate(row) ? (getBookedDate(row) | date: 'shortDate') : '—' }}</td>

            <td>
              <span class="week-pill">{{ getYywwLabel(row) }}</span>
            </td>

            <td>
              <span class="hours">{{ row.hours | number: '1.2-2' }}</span>
            </td>

            <td>
              <span class="status-pill" [ngClass]="getApprovalClass(row)">
                {{ getApprovalStatus(row) }}
              </span>
            </td>

            <td>{{ getPayCodeLabel(row) }}</td>

            <td>{{ getPayGroupName(row) }}</td>

            <td>{{ getProjectName(row) }}</td>

            <td>{{ getCompanyName(row) }}</td>

            <td>{{ getDepartmentLabel(row) }}</td>

            <td>{{ getWorkerTypeName(row) }}</td>

            <td>
              <span class="won-text" [title]="getWorkOrderLabel(row)">
                {{ getWorkOrderLabel(row) }}
              </span>
            </td>

            <td>
              <div class="date-cell">
                <span>
                  {{ getSupervisorApprovedAt(row) ? (getSupervisorApprovedAt(row) | date: 'shortDate') : '—' }}
                </span>
                <span class="muted">
                  {{ getSupervisorApprovedAt(row) ? (getSupervisorApprovedAt(row) | date: 'shortTime') : '' }}
                </span>
                <span class="muted">By {{ getSupervisorApprovedBy(row) }}</span>
              </div>
            </td>

            <td>
              <div class="date-cell">
                <span>{{ getUpdatedAt(row) ? (getUpdatedAt(row) | date: 'shortDate') : '—' }}</span>
                <span class="muted">{{ getUpdatedAt(row) ? (getUpdatedAt(row) | date: 'shortTime') : '' }}</span>
                <span class="muted">By {{ getUpdatedBy(row) }}</span>
              </div>
            </td>
          </tr>

          <tr *ngIf="!isLoading && !rows.length">
            <td colspan="17" class="empty">No booked hour history found.</td>
          </tr>

          <tr *ngIf="isLoading">
            <td colspan="17" class="empty">Loading booked hours...</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <span>Page {{ pageNumber }} of {{ totalPages }} — {{ totalCount }} total records</span>

      <div class="pager-actions">
        <button type="button" class="ghost-btn" (click)="previousPage()" [disabled]="pageNumber <= 1 || isLoading">
          Previous
        </button>

        <button type="button" class="ghost-btn" (click)="nextPage()" [disabled]="pageNumber >= totalPages || isLoading">
          Next
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading" class="busy-overlay">
    <div class="spinner"></div>
  </div>
</div>